<template>
  <div id="mypage">
    <p
      v-for="(pagedata, key1, index1) in pages"
      :key="'p' + index1"
      class="savebtns"
    >
      <span
        v-for="(data, index) in pagedata"
        @click="save(key1, index)"
        :key="index"
      >
        保存{{ wnjianname[key1] }}第{{ index + 1 }}页二维码
      </span>
    </p>
    <div
      v-for="(imglistson, key1, index1) in imglists"
      :key="index1"
      class="myqrcodef"
    >
      <p style="width:100%">{{ key1 }}</p>
      <div
        class="qrcodef"
        v-for="(data, index) in imglistson"
        :id="'imglistbox' + key1 + index"
        :key="index"
        :order="data.order"
      >
        <div class="logoimg">
          <div></div>
        </div>
        <div class="qrcode" :id="'qrCodeUrl' + key1 + index"></div>
      </div>
    </div>
    <template v-for="(data, index) in imgUrl">
      <img :src="data" alt="" :key="index" />
    </template>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      imglist: [],
      alldatas: alldatas,
      imglists: {},
      imgUrl: [],
      showsavebox: 0,
      pagesize: 10,
      pages: {},
      nowpage: 1,
      wnjianname: {
        A: "泸顺起义陈列馆"
      }
    };
  },
  components: {},
  computed: {},
  methods: {
    creatQrCode() {
      for (let key in this.alldatas) {
        this.imglists[key].forEach((e, i) => {
          var qrcode = new QRCode("qrCodeUrl" + key + i, {
            text: "http://audio.lushun.riesun.cn/#/Home?a=" + e.name,
            width: 432,
            height: 432,
            colorDark: "#000000",
            colorLight: "rgba(255,255,255,0)",
            correctLevel: QRCode.CorrectLevel.H
          });
        });
      }
    },
    save(key, index) {
      // this.imglist.forEach((e,i) => {
      //    this.toImage(i)
      // })
      let starnum = index * 10;
      let endnum = index * 10 + 10;
      console.log();
      for (let i = starnum; i < endnum; i++) {
        this.toImage(key, i);
      }
    },
    toImage(key, i) {
      html2canvas(document.getElementById("imglistbox" + key + i), {
        backgroundColor: "rgba(0,0,0,0)"
      }).then(canvas => {
        setTimeout(() => {
          let dataURL = canvas.toDataURL("image/png");
          let alink = document.createElement("a");
          alink.href = dataURL;
          alink.download =
            this.imglists[key][i].order + "_" + this.imglists[key][i].chname; //图片名
          alink.click();
        }, 1000);
        // this.imgUrl.push(dataURL);
      });
    }
  },
  created() {
    let imglists = {
      A: []
    };
    const files = require
      .context("@/assets/img/audioimg", true, /\.*\.jpg|jpeg|png$/)
      .keys();
    files.forEach(e => {
      let nn = e.slice(2).split("-");
      for (let key in this.alldatas) {
        let chname;
        let describe;
        let order;
        chname = "";
        this.alldatas[key].forEach((item, index) => {
          if (nn[0] == item.number) {
            chname = item.name;
            describe = item.describe;
            order = item.ordernum ? item.ordernum : item.order;
          }
        });
        console.log(nn[2]);
        if (!chname) {
          // console.log(nn[0])
        } else {
          imglists[key].push({
            img: require("@/assets/img/audioimg" + e.slice(1)),
            name: nn[0],
            chname: chname,
            describe: describe,
            order: order
          });
        }
      }
    });
    console.log(imglists);
    this.imglists = imglists;
    let pages = {
      A: ""
    };
    for (let key in imglists) {
      let tpages = Math.ceil(imglists[key].length / this.pagesize);
      pages[key] = tpages;
    }
    this.pages = pages;
  },
  mounted() {
    setTimeout(this.creatQrCode(), 5000);
  }
};
</script>

<style>
body {
  background: none;
}
#mypage {
  overflow: auto;
  height: 100vh;
}
.myqrcodef {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.savebox {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 21;
  background-color: rgba(0, 0, 0, 0.5);
}
.savebtns {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.savebtns > span {
  background-color: red;
  border-radius: 25px;
  height: 30px;
  line-height: 30px;
  padding: 0 5px 0 5px;
  color: #fff;
  margin-left: 10px;
  margin-bottom: 5px;
}
.qrcodef {
  width: 500px;
  height: 500px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  background: none;
}
.logoimg {
  width: 114px;
  height: 114px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, .5); */
}
.logoimg > div {
  width: 100px;
  height: 100px;
  border-radius: 14px;
  background-color: rgb(255, 255, 255);
  background-image: url(../assets/img/logo.png);
  background-size: 90% auto;
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/view/qrcode.vue